import { VendasApiUrl } from "../globals.js";
import axios from "axios";

export default {
  data: () => ({
    valorPlanoDental: 10,
    valid: false,
    sendingData: false,
    venda: {},
    account: {
      nome: "",
      profissao: "",
      sexo: "",
      cpf: "",
      rg: "",
      rg_orgao_emissor: "",
      nascimento: "",
      indicado: "",
    },
    contacts: {
      whatsapp: "",
      celular: "",
      celular_2: "",
      dono_celular_2: "",
      telefone: "",
      email: "",
    },
    address: {
      cep: "",
      rua: "",
      numero: "",
      complemento: "",
      cidade: "",
      bairro: "",
      uf: "",
    },
    documents: [],
    documentsUploaded: [],
    payment: {
      forma_pagamento_adesao: "",
      forma_pagamento: "",
      isento_adesao: false,
    },
    members: [],
    contratante_associado: false,
    contratante_plano_dental: false,
  }),

  computed: {
    members_length() {
      /*
        Se tiver id é pq esá sendo editado,
        logo, precisa considerar os associados
        adicionados anteriormente e os associados
        que serão deletados
      */

      if (this.id) {
        if (this.contratante_associado) {
          let members =
            this.members.length +
            this.savedMembers.length -
            this.membersToDelete.length;
          return members + 1;
        } else {
          let members =
            this.members.length +
            this.savedMembers.length -
            this.membersToDelete.length;
          return members;
        }
      } else {
        if (this.contratante_associado) {
          return this.members.length + 1;
        } else {
          return this.members.length;
        }
      }
    },

    totalDeAssociadosComPlanoDental() {
      let associados = this.members.filter(
        (i) => i.plano_dental == true,
      ).length;
      let contratante = this.contratante_plano_dental ? 1 : 0;
      return associados + contratante;
    },
    valorCalculadoPlanoDental() {
      return this.totalDeAssociadosComPlanoDental * this.valorPlanoDental;
    },

    valor_adesao() {
      if (this.payment.isento_adesao) {
        return 0;
      } else {
        let dental = this.valorCalculadoPlanoDental;
        if (this.VALOR_INCREMENTAVEL) {
          let mensal = this.VALOR_MENSAL * this.members_length;
          return mensal + dental;
        } else {
          let mensal = this.VALOR_MENSAL;
          return mensal + dental;
        }
      }
    },
  },

  methods: {
    setContratanteAssociado(val) {
      this.contratante_associado = val;
    },
    setContratantePlanoDental(val) {
      this.contratante_plano_dental = val;
    },

    checkoutForm() {
      const documentsForm = this.$refs.documentsForm;

      if (documentsForm && documentsForm.processing) {
        this.$notify.error({
          msg: "Aguarde o processamento dos documentos antes de concluir a venda.",
        });
        return;
      }

      if (this.$refs.checkoutForm.validate()) {
        if ((!Array.isArray(this.documents) || this.documents.length <= 0) && (!this.id || !Array.isArray(this.uploadedDocuments) || this.uploadedDocuments.filter((doc) => !this.documentsToDelete.includes(doc.id)).length === 0)) {
          this.$notify.error({
            msg: "Adicione algum documento.",
          });
        } else if (this.members_length <= 0) {
          this.$notify.error({
            msg: "Adicione algum associado.",
          });
        } else {
          this.salvarVenda();
        }
      } else {
        alert(
          "Alguns campos obrigatórios não foram preenchidos. Preencha-os e tente salvar novamente.",
        );
      }
    },
    loading() {
      this.$loading(true);
    },
    sendDocs(id_venda) {
      return new Promise((resolve, reject) => {
        let documentos = this.documents.map((i) => {
          return {
            id_venda,
            documento: i,
          };
        });
        console.log("docs");
        axios
          .post(VendasApiUrl + "/api/vendas/documentos", {
            documentos,
          })
          .then(() => resolve())
          .catch((err) => reject(err));
      });
    },

    sendMembers(id_venda) {
      return new Promise((resolve, reject) => {
        let associados = this.members.map((i) => {
          return {
            id_venda,
            cpf: i.cpf,
            nome: i.nome,
            parentesco: i.parentesco,
            nascimento: i.nascimento,
            telefone: i.telefone || "",
            registro_nascimento: i.registro_nascimento || 0,
          };
        });
        if (associados.length) {
          axios
            .post(VendasApiUrl + "/api/vendas/associados", {
              associados,
            })
            .then(() => resolve())
            .catch((err) => reject(err));
        } else {
          resolve();
        }
      });
    },
  },
};
